/*
  The Audio Tailor: recently viewed products (loaded by sections/recently-viewed.liquid).
  On a product page, the product's handle is saved to localStorage. When the section nears the viewport,
  cards for the other saved handles are fetched from the product-card-fragment section (one small request
  each, in parallel) and shown in a scroll row. Handles that no longer exist are dropped.
*/

const TAT = window.TAT || {};
const KEY = 'tat:recently-viewed';
const MAX_STORED = 12;

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
  } catch {
    /* storage full or blocked: recently viewed is a convenience only */
  }
};

const productUrl = (handle) => {
  const root = (TAT.routes?.root || '/').replace(/\/$/, '');
  return `${root}/products/${encodeURIComponent(handle)}`;
};

class TatRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.handle || '';
    const limit = Number(this.dataset.limit) || 6;
    const history = read();
    this.handles = history.filter((h) => h !== current).slice(0, limit);
    if (current) write([current, ...history.filter((h) => h !== current)]);

    if (!this.handles.length) return;
    // The element stays hidden until it has cards, so watch its (visible, empty) section wrapper instead.
    if (TAT.onVisible) TAT.onVisible(this.parentElement || this, () => this.render(), '600px');
    else this.render();
  }

  async render() {
    const list = this.querySelector('[data-recently-viewed-list]');
    if (!list || !TAT.fetchSection) return;
    const results = await Promise.allSettled(
      this.handles.map((handle) => TAT.fetchSection(productUrl(handle), 'product-card-fragment'))
    );

    const missing = [];
    results.forEach((result, i) => {
      if (result.status !== 'fulfilled') {
        if (/404/.test(String(result.reason?.message))) missing.push(this.handles[i]);
        return;
      }
      const doc = new DOMParser().parseFromString(result.value, 'text/html');
      const card = doc.querySelector('[data-card-fragment]');
      if (card) list.appendChild(card);
    });

    if (missing.length) write(read().filter((h) => !missing.includes(h)));
    if (list.children.length) {
      this.hidden = false;
      this.querySelector('tat-scroll-row')?.update?.();
    }
  }
}
if (!customElements.get('tat-recently-viewed')) customElements.define('tat-recently-viewed', TatRecentlyViewed);
